import gql from 'graphql-tag'
import { EMAIL_ENVELOPE_FRAGMENT } from './Email'
import {
  ACCOUNT_FRAGMENT,
  CLIENT_FRAGMENT,
  PROJECT_TYPE_FRAGMENT,
  RESOURCE_FRAGMENT,
  TEAM_FRAGMENT,
} from './Organization'

export const COMMENT_STATE_FRAGMENT = gql`
  fragment CommentStateFragment on CommentsState {
    hasComments
    unreadCommentsCount
  }
`

export const COMMENT_REMINDER_FRAGMENT = gql`
  fragment CommentReminderFragment on CommentReminder {
    id
    type
    remindAt {
      seconds
    }
  }
`

export const COMMENT_RECIPIENT_USER_FRAGMENT = gql`
  fragment CommentRecipientUserFragment on CommentRecipientUser {
    isRead
    isTeamMember
    sendEmail
    user {
      ...AccountFragment
    }
  }
  ${ACCOUNT_FRAGMENT}
`
export const COMMENT_RECIPIENT_TEAM_FRAGMENT = gql`
  fragment CommentRecipientTeamFragment on CommentRecipientTeam {
    isRead
    sendEmail
    team {
      ...TeamFragment
    }
  }
  ${TEAM_FRAGMENT}
`

export const COMMENT_DEADLINE_REQUEST_FRAGMENT = gql`
  fragment CommentDeadlineRequestFragment on DeadlineRequest {
    task {
      id
      name
    }
    status
    proposedDeadline {
      seconds
    }
    setDeadline {
      seconds
    }
  }
`

export const COMMENT_FRAGMENT = gql`
  fragment CommentFragment on Comment {
    id
    createdAt {
      seconds
      nanos
    }
    updatedAt {
      seconds
    }
    emailSubject
    inboundEmailEnvelope {
      ...EmailEnvelopeFragment
    }
    outboundEmailEnvelope {
      ...EmailEnvelopeFragment
    }
    user {
      ...AccountFragment
    }
    onBehalfOf {
      ...AccountFragment
    }
    text
    parentCommentId
    recipients {
      users {
        ...CommentRecipientUserFragment
      }
      teams {
        ...CommentRecipientTeamFragment
      }
    }
    resources {
      ...ResourceFragment
    }
    reminder {
      ...CommentReminderFragment
    }
    deadlineRequest {
      ...CommentDeadlineRequestFragment
    }
    likeDetails {
      likesCount
      isLikedByUser
    }
  }
  ${COMMENT_RECIPIENT_USER_FRAGMENT}
  ${COMMENT_RECIPIENT_TEAM_FRAGMENT}
  ${ACCOUNT_FRAGMENT}
  ${RESOURCE_FRAGMENT}
  ${COMMENT_REMINDER_FRAGMENT}
  ${COMMENT_DEADLINE_REQUEST_FRAGMENT}
  ${EMAIL_ENVELOPE_FRAGMENT}
`

export const MY_TASK_FRAGMENT = gql`
  fragment MyTaskFragment on Task {
    id
    parentTaskId
    rootTaskId
    name
    status
    type
    parentEntityType
    project {
      id
      name
      userAccess
      access
      projectType {
        name
      }
      hasPriority
      reference
      image {
        id
      }
      responsible {
        ...AccountFragment
      }
      clients {
        ...ClientFragment
      }
      assignedProducers {
        id
        producer {
          id
          name
        }
      }
    }
    milestone {
      id
      name
    }
    goal {
      id
      name
      boards {
        id
        name
        userAccess
      }
    }
    owner {
      ...AccountFragment
    }
    assignees {
      ...AccountFragment
    }
    followers {
      ...AccountFragment
    }
    teamFollowers {
      ...TeamFragment
    }
    deadline {
      seconds
    }
    executionDate {
      seconds
    }
    remindMe {
      seconds
    }
    commentsState {
      ...CommentStateFragment
    }
  }
  ${ACCOUNT_FRAGMENT}
  ${TEAM_FRAGMENT}
  ${PROJECT_TYPE_FRAGMENT}
  ${CLIENT_FRAGMENT}
  ${COMMENT_STATE_FRAGMENT}
`

export const DASHOBARD_TASK_FRAGMENT = gql`
  fragment DashboardTaskFragment on Task {
    id
    parentTaskId
    rootTaskId
    parentEntityType
    name
    type
    deadline {
      seconds
    }
    commentsState {
      ...CommentStateFragment
    }
  }
  ${COMMENT_STATE_FRAGMENT}
`

export const RECURRING_TASK_DEFINITION_FRAGMENT = gql`
  fragment RecurringTaskDefinitionFragment on RecurringTaskDefinition {
    id
    projectId
    milestoneId
    goal {
      id
      name
      boards {
        id
        userAccess
      }
    }
    owner {
      ...AccountFragment
    }
    assignees {
      ...AccountFragment
    }
    followers {
      ...AccountFragment
    }
    name
    description
    status
    deadline {
      seconds
    }
    recurringPeriod
    recurringEnd {
      seconds
    }
    recurringPeriodInterval
    createDaysBeforeDeadline
    occurrences
    estimatedHours
    daysOfMonthList
    daysOfWeekList
    onDateOfYear {
      seconds
    }
    startDate {
      seconds
    }
    tasksConfig {
      name
      estimatedHours
      assigneeId
      description
    }
  }
  ${ACCOUNT_FRAGMENT}
`

export const TASK_DETAILS_COUNTERS_FRAGMENT = gql`
  fragment TaskDetailsCountersFragment on TaskDetailsCounters {
    taskId
    resourcesCount
    commentsCount
  }
`

export const LOGGED_TIME_FRAGMENT = gql`
  fragment LoggedTimeFragment on LoggedTime {
    id
    hours
    rate
    time {
      seconds
    }
  }
`

export const TASK_INFO_FRAGMENT = gql`
  fragment TaskInfoFragment on Task {
    id
    name
  }
`

export const TASK_DIRECT_SOURCE_FILTER_FRAGMENT = gql`
  fragment TaskDirectSourceFilterFragment on TaskDirectSourceFilter {
    id
    value
    type
  }
`
